<div class="capacity">
  <h4>
    {{ "title.capacity" | translate | async }}
  </h4>
  <p>{{ 'message.setCapacity.bulkEdit.capacityInstructions' | translate | async }}</p>
</div>
<vue-radio-group (change)="toggleSelectedRadioButton($event)" [value]="selectedRadioButton"
  [items]="capacityRadioButtons" [getItemDisplay]="getRadioDisplay"></vue-radio-group>
<div [formGroup]="capacityForm">
  <!-- {{ capacityForm.value | json }} -->
  <ng-template #newCapacityRef>
    <div class="radio-button-ref">
      <vue-numeric-input formControlName="count" label="{{ 'title.capacity' | translate | async }}" alignText="left"
        [errorMatcher]="suppressErrorState" [maxLength]="5"></vue-numeric-input>
    </div>
  </ng-template>
  <ng-template #alterCapacityRef>
    <div style="margin-left: -10px; display: flex;">
      <mat-checkbox formControlName="isBalanceCapacity">
            {{ "title.balancecapacity" | translate | async }}
      </mat-checkbox>
      <div class="tooltipInside" >
   <vue-image-tooltip imageSrc="/assets/icons/icon-exclamation.svg"
              content="{{'tooltip.message.balancecapacity' | translate | async }}"></vue-image-tooltip>
      </div>
   
    </div>
    <div class="radio-button-ref">
      <vue-select formControlName="type" label="{{ 'title.logic' | translate | async }}"
        [options]="alterCapacityOptions" [getOptionDisplay]="getAlterOptionText.bind(this)"
        [errorMatcher]="suppressErrorState"></vue-select>
      <vue-numeric-input formControlName="count" label="{{ 'title.capacity' | translate | async }}" alignText="left"
        [errorMatcher]="suppressErrorState" [maxLength]="5"></vue-numeric-input>
    </div>
  </ng-template>
</div>